interface TextContentProps {
  content: string;
}

export const TextContent = ({ content }: TextContentProps) => (
  <div className="text-light text-sm">{content}</div>
);
